export function createAsyncMiddleware({ dispatch, getState, }) {
    return (next) => (action) => {
        const { types, callAPI, shouldCallAPI, ...extraProps } = action;
        if (!isActionValid(action))
            return next(action);
        if (typeof shouldCallAPI === 'function' && !shouldCallAPI(getState()))
            return Promise.resolve();
        const [pendingType, successType, errorType] = types;
        // @ts-expect-error FIXME
        dispatch({ type: pendingType, ...extraProps });
        return callAPI(getState)
            .then((response) => {
            dispatch({
                // @ts-expect-error FIXME
                type: successType,
                data: response,
                ...extraProps,
            });
        })
            .catch((error) => {
            dispatch({
                // @ts-expect-error FIXME
                type: errorType,
                error,
                ...extraProps,
            });
        });
    };
}
const isActionValid = (action) => {
    if (action.types && Array.isArray(action.types)) {
        const matches = action.types.filter((type) => type.endsWith('SUCCESS') ||
            type.endsWith('PENDING') ||
            type.endsWith('ERROR'));
        return matches.length === 3;
    }
    return false;
};
//# sourceMappingURL=creator.js.map